import React, { useState, useEffect, useRef, useContext } from "react";
import styles from "./ModalFirstEnterSale.module.scss";
import { useTranslation } from "react-i18next";
import ArrowDropdown from "../../img/IconComponents/ArrowDropdown";
import cn from "classnames";
import Checkbox from "../Checkbox/Checkbox";
import { Context } from "../../index";
import { FRONT_URL } from "../../http";
import { useNavigate } from "react-router-dom";

const ModalFirstEnterSale = ({ sendAccept }) => {
  const { store } = useContext(Context);
  const { t, i18n } = useTranslation();
  const [isEndReached, setIsEndReached] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const navigate = useNavigate();
  const bottomRef = useRef(null);

  const scrollToBottom = () => {
    bottomRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;

    if (scrollTop + clientHeight >= scrollHeight - 1) {
      setIsEndReached(true);
    } else {
      setIsEndReached(false);
    }
  };

  useEffect(() => {
    const scrollContainer = document.getElementById("scroll-container");
    scrollContainer.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.modal}>
      <div className={styles.modal__inner}>
        <div className={styles.modal__title}>
          {t("We have updated our contract for Sales.")}
        </div>
        <div className={styles.modal__content} id="scroll-container">
          <div className={styles.modal__content_bold}>
            {t("TIPSTER AGREEMENT")}
          </div>
          <div className={styles.modal__content_bold}>
            {t("for the use of the Tipster Program on the online presence")}
          </div>
          <div className={styles.modal__content_bold}>
            "www.Anbaugesellschaft.de"
          </div>
          <div className={styles.modal__content_bold}>{t(" of")}</div>
          <div className={styles.modal__content_bold}>
            Deutsche Anbaugesellschaft DAG GmbH
            <br />
            {t("in the version of [*].2023")}
          </div>
          <div className={styles.modal__note}>
            <div>*</div>
            {t(
              "Please review the updated contract and agree to the contents. Once you confirm the new contract, the current contract will be terminated. You will then be able to use our platform again as usual."
            )}
          </div>
          <div className={styles.modal__content_title}>1. {t("General")}</div>
          <div className={styles.modal__content_text}>
            {t(
              "Deutsche Anbaugesellschaft DAG GmbH, (hereinafter: 'DAG'), Mittelweg 144, 20148 Hamburg, online presence https://anbaugesellschaft.de/ (hereinafter: 'Platform') has launched a tipster program (hereinafter 'Tipster Program'). The legal relationship between DAG and the participating tipsters (hereinafter 'Tipsters') is subject to the following regulations:"
            )}
          </div>

          <div className={styles.modal__content_title}>
            2. {t("Conclusion of the Tipster Agreement")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "2.1 The contractual relationship between DAG and the tipster (hereinafter 'Tipster Agreement') is established as follows"
            )}
            :
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "- Participation in the Tipster Program is exclusively by invitation and takes place on the internet platform https://Anbaugesellschaft.de/. By registering via an invitation link, the tipster expresses interest in participating in the Tipster Program."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "- By means of an explicit declaration via e-mail, DAG informs the tipster that it accepts his offer to conclude the Tipster Agreement under the conditions stated here and then activates him for participation in the Tipster Program on the online presence."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "2.2 Upon activation, the Tipster Agreement is established according to the contract terms available on the platform in the respective valid version. Deviating agreements only apply if their validity has been expressly agreed upon at least in text form."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "2.3 There is no entitlement to participate in the Tipster Program; DAG has the right to refuse the activation of tipsters without stating reasons or to revoke it at any time without stating reasons."
            )}
          </div>

          <div className={styles.modal__content_title}>
            3. {t("Subject of the Tipster Agreement")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "3.1 The subject of the Tipster Agreement is the promotion of DAG and its business activities by the tipster directing potentially interested parties to DAG's homepage. In return, the tipster receives a corresponding compensation (hereinafter 'Compensation') from DAG. The prerequisites and details are regulated in clause 8 of the Tipster Agreement."
            )}
          </div>

          <div className={styles.modal__content_text}>
            {t(
              "3.2 For the promotion of the platform, the tipster can use both the platform itself and other channels available to him (social media, e-mail newsletters, etc.) and draw attention to the platform by using an individually generated code for the tipster (“Tipster-ID”). This allows for a technical recording and allocation of the tipster activities."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "3.3 The tipster commits to limit his advertising activity to directing potential interested parties to the online presence https://anbaugesellschaft.de/ and to refrain from any consulting of the interested parties and/or statements regarding the design or economic benefits related to the activities of DAG described on the platform or the products and services advertised there, as well as investment projects including any token emissions. Corresponding inquiries from interested parties are to be answered by referring to the information offered on the online presence https://anbaugesellschaft.de/."
            )}
          </div>
          <div className={styles.modal__content_title}>
            4. {t("Contractual Cooperation")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "4.1 The tipster may only act as a tipster for promoting the platform after the successful conclusion of the tipster contract in accordance with clause 2.1."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "4.2 DAG and the tipster act as independent individuals in their own name and for their own account when executing this contract. The tipster is not authorized to make declarations for DAG or use the name and logo without prior consent. Therefore, he/she will not act as a representative or agent of DAG, the companies affiliated with DAG, the provider and/or the issuer, and will not appear as such."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "4.3 The activity of the tipster is limited to directing potentially interested parties to DAG's online presence. Questions about the specific activities of DAG described on the platform or the products and services advertised there, as well as investment projects including any token emissions, will be answered by the contracting party exclusively by referring to the information provided on DAG's online presence. The tipster acts solely as a tipster for promoting the platform. This means that he/she is particularly committed to not conducting any investment brokerage or investment advice regarding the investment opportunities offered by DAG on the platform. His/her activity is limited to establishing contact between interested parties and DAG by providing a link to DAG's homepage. He/she is not authorized to create independent advertising materials. The contractual partner is excluded from participating in the specific presentation, the specific offer, the specific preparatory actions (e.g. recording new customer data for use by DAG) and contract negotiations as well as the conclusion of contracts."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "4.4 In addition, the tipster commits to pointing out that he/she does not conduct investment brokerage or investment advice and that his/her activity is limited to establishing contact between interested parties and DAG by providing a link to DAG's homepage."
            )}
          </div>

          <div className={styles.modal__content_title}>
            5. {t("Rights and Obligations of the Tipster")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "5.1 Only legally and commercially capable natural and legal persons may participate as tipsters in the tipster program."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "5.2 The tipster is obliged to ensure the accuracy of all contact, profile, and payment data stored within the framework of the tipster program and to keep them up to date at all times. The tipster will immediately notify any changes via his/her 'Tipster Dashboard' or by email to service@Anbaugesellschaft.de. DAG assumes no liability for any damages resulting from incorrect, delayed, or non-updated information."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "5.3 The tipster carries out his/her activity within the framework of the tipster contract as a self-employed person and can freely decide on the temporal and spatial allocation of his/her activity. He/she is not subject to instructions from DAG."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "5.4 The tipster must carry out the tasks assumed with the diligence of a prudent businessman and in compliance with applicable law. He/she is particularly committed to refraining from disseminating content that violates applicable law or good morals (pornographic, sexist, discriminatory, and politically extremist content) on the platform as well as on his/her own websites or third-party websites (including banner advertising, etc.) within the scope of his/her tipster activity."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "5.5 The tipster will also observe the provisions of the Act Against Unfair Competition (UWG) when carrying out his/her activity. The performance of unfair business practices is expressly prohibited. In particular, the tipster will not undertake any advertising measures that are to be regarded as unreasonable harassment within the meaning of § 7 UWG (e.g., the sending of advertising emails without the prior explicit consent of the potential interested party/recipient of the advertising measure)."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "5.6 The tipster alone bears the responsibility for compliance with the legal permit requirements as well as the tax and social insurance law provisions. The tipster will take care of obtaining any official approvals or permits required for the exercise of his/her activity in a timely and independent manner and will prove these to DAG upon their request."
            )}
          </div>
          <div className={styles.modal__content_title}>
            6. {t("Rights and Obligations of DAG")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "6.1 For the purpose of promoting DAG and the platform, DAG will send the tipster a link to DAG's homepage that can be assigned to the tipster. The tipster is not authorized to change the information, documents, and advertising materials of DAG in any way. The tipster is also not authorized to make statements deviating from DAG's statements within the scope of his/her tipster activity. In particular, he/she may not make any statements about the activities of DAG described on the platform or the products and services advertised there, as well as investment projects including any token emissions, or about the information, documents, and advertising materials provided by DAG to the interested parties."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "6.2 DAG reserves the right to reclaim already paid compensations from the tipster if the new customers can claim that the contracts were demonstrably induced by the tipster's statements."
            )}
          </div>

          <div className={styles.modal__content_text}>
            {t(
              "6.3 DAG will ensure the proper billing and payment of compensation. However, the technical integration required to ensure correct billing lies solely in the responsibility of the tipster. DAG assumes no liability for any disadvantages that arise for the tipster due to incorrect integration."
            )}
          </div>
          <div className={styles.modal__content_title}>
            7. {t("Assurances of the Tipster")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "With the registration for participation in the tipster program, the tipster assures DAG that"
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "a. the information provided by him/her in the registration form is comprehensive and accurate;"
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "b. he/she will not change the information, documents, and advertising materials of DAG in any way during the term of the tipster contract."
            )}
          </div>
          <div className={styles.modal__content_title}>
            8. {t("Amount and Payment of Remuneration")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "8.1 During the term of the tipster contract, the tipster receives remuneration from DAG (including any applicable sales tax). The amount of remuneration is based on the remuneration table applicable at the time of contract conclusion with the new customer. The current remuneration table is an integral part of this agreement."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "8.2 The claim to remuneration payment arises only and when the following conditions cumulatively exist:"
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t("a. Successful receipt of payment from the new customer;")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "b. Expiry of the two-week withdrawal period without the new customer's revocation;"
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "8.3 The tipster is aware that DAG can reject the registration of a new customer or their contract offer on the platform. The tipster has no claim against DAG for accepting a contract offer from a potential new customer."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "8.4 The tipster's claim to remuneration lapses if the contract with the new customer is void from the outset or becomes void or is reversed for reasons not attributable to DAG. Any remuneration already paid must be reimbursed to DAG by the tipster in this case."
            )}
          </div>

          <div className={styles.modal__content_title}>9. {t("Billing")}</div>
          <div className={styles.modal__content_text}>
            {t(
              "9.1 DAG provides the tipster with a statement of the remuneration incurred in the past month (hereinafter 'billing period') according to clause 8, each after the end of the month. The remuneration payment, possibly plus VAT, is made cumulatively for the past billing period, each on the 15th banking day of the following month."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "9.2 If the tipster does not object to a statement within a period of 4 weeks after receipt, it is considered approved."
            )}
          </div>

          <div className={styles.modal__content_title}>
            10. {t("Liability and Limitation")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "10.1 DAG's liability for damages to the tipster is excluded. The exclusion of liability does not apply in cases of intent or gross negligence by DAG or its respective agents. In the case of a breach of essential contractual duties, DAG is liable for any negligence, but limited to the typical, foreseeable damage. Essential is any duty that enables the proper execution of the tipster contract and whose non-fulfillment would endanger the achievement of the contract's purpose. The aforementioned limitations of liability do not apply in cases of liability for personal injury."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "10.2 The tipster shall compensate DAG for all damages arising from the violation of respective legal or contractual obligations or false assurances under this tipster contract and shall indemnify DAG from claims by third parties or liabilities towards third parties, of any kind including officially imposed fines and/or penalties."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "10.3 Claims for damages by the tipster, for which the liability is limited according to clause 10.1, become statute-barred one year from the legal limitation period beginning. This does not apply to claims from tort."
            )}
          </div>
          <div className={styles.modal__content_title}>
            11. {t("Contract Duration and Termination")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "11.1 The tipster contract has no minimum term, but is indefinite."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "11.2 The tipster contract can be terminated by both parties at any time with a notice period of 14 days. The tipster can declare the termination of the tipster contract to DAG in text form by email to service@Anbaugesellschaft.de. In the case of termination of the tipster contract by DAG, the notice of termination will be sent to the email address stored in the tipster's account. The right of the parties to extraordinary termination of the contract for important reason remains unaffected."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "11.3 After termination of the tipster contract, the tipster is not allowed to continue using the link assigned to him/her to DAG's platform."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "11.4 Upon termination of the agreement, the tipster is no longer entitled to claims for remuneration according to clause 8 or other payment claims related to the termination of the tipster contract. Exempted are claims for remuneration that arose before the termination of the contract, as well as any claims for damages due to culpable behavior by DAG."
            )}
          </div>
          <div className={styles.modal__content_title}>
            12. {t("Changes to the Tipster Contract")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "12.1 DAG reserves the right to change the tipster contract at any time. Changes to the tipster contract and the introduction of additional conditions (hereinafter collectively 'changes') will be sent to the tipster by email at least six weeks before the proposed effective date."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "12.2 A tipster's consent to the changes is considered granted if the respective tipster does not object in writing (addressed to DAG at the address given in the imprint) or by email (to service@Anbaugesellschaft.de) before the proposed effective date of the changes. DAG will specifically point out this approval effect each time the changes are transmitted."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "12.3 If the tipster objects to the changes, DAG is entitled to terminate the tipster contract with effect from the day on which the changes come into effect."
            )}
          </div>
          <div className={styles.modal__content_title}>
            13. {t("Confidentiality Obligation, Confidentiality")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "13.1 The tipster commits to treating all information and documents confidentially that are transmitted to him/her under this contract and that must be classified as confidential according to the circumstances of disclosure (hereinafter 'confidential information'). Confidential information also includes sales and marketing strategies and this sales agreement. Information about third parties can also be confidential information. The tipster commits to protecting the confidential information with the same care that he/she applies to his/her own information of the same importance."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "13.2 This confidentiality obligation continues to apply even after the contract ends."
            )}
          </div>
          <div className={styles.modal__content_title}>
            14. {t("Final Provisions")}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "14.1 If a provision of the tipster contract is invalid, the contract remains effective in other respects."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "14.2 The contract and communication language is German. Subject to other information provided by DAG to the tipster in individual cases, other languages are not available as contract or communication languages."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "14.3 The law of the Federal Republic of Germany applies, excluding the conflict of laws rules of the EGBGB and the provisions of the UN Sales Convention (CISG). Mandatory legal provisions (especially consumer protection regulations) of another state in which the new customer has his/her residence remain applicable."
            )}
          </div>
          <div className={styles.modal__content_text}>
            {t(
              "14.4 If there is no exclusive statutory jurisdiction, the court at DAG's seat is exclusively responsible for all disputes arising from or in connection with the tipster contract, provided the tipster is a merchant, or a legal entity or has no general jurisdiction in Germany or another EU member state or has moved his/her (residential) seat to a non-EU foreign country after the tipster contract comes into effect."
            )}
          </div>
          <div className={styles.modal__content_bottom}>
            <div className={styles.modal__content_bold}>
              {t("Compensation Table as an addition to the Tipster Agreement")}
            </div>
            <div className={styles.modal__content_bold}>
              {t("for the use of the Tipster Program on the online presence")}
            </div>
            <div className={styles.modal__content_bold}>
              "www.Anbaugesellschaft.de"
            </div>
            <div className={styles.modal__content_bold}>{t(" of")}</div>
            <div className={styles.modal__content_bold}>
              Deutsche Anbaugesellschaft DAG GmbH
            </div>
            <div className={styles.modal__content_bold}>
              {t("in the version of")} [*].2023
            </div>
            <table className={styles.modal__content_table}>
              <thead>
                <tr>
                  <td>{t("Product")}</td>
                  <td>{t("Remuneration")}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowSpan={2}>
                    {t(
                      "Remuneration for all products that are purchased from Deutsche Anbaugesellschaft DAG GmbH within a period of 24 months from the first contract conclusion. This includes all products available on the platform at that point in time."
                    )}
                  </td>
                  <td>{t("15 Percent")}</td>
                </tr>
              </tbody>
            </table>
            <div className={styles.modal__content_title}>
              {t("Explanations of the Table Presented Above")}
            </div>

            <div className={styles.modal__content_text}>
              {t(
                "In this table, various products or services are listed, for which the Tipper is paid commissions. The amount of commission is in accordance with the rates specified in the table and as per the terms set in this contract."
              )}
            </div>
            <div className={styles.modal__content_text}>
              {t(
                "The Tipper is entitled to receive commissions as per the rates set in this table, provided all conditions in this contract and the applicable laws and regulations are met. The payment of commissions is made in accordance with the terms set in this contract and the stipulated timelines. This can regularly occur after the conclusion of a business transaction."
              )}
            </div>
            <div className={styles.modal__content_text}>
              <b>{t("Changes to the Table:")}</b>{" "}
              {t(
                "The Client reserves the right to amend the commission rates and conditions in this table at their discretion. Such changes will be announced on the platform and must be confirmed by the Tipper."
              )}
            </div>
          </div>

          <label className={styles.modal__check}>
            <Checkbox
              value={isCheck}
              onChange={(e) => setIsCheck(e.target.checked)}
            />
            <div>
              {t(
                "I have read, understood and fully accepted the updated Tipster Agreement."
              )}
            </div>
          </label>
          <div ref={bottomRef}></div>
        </div>
        <div className={styles.modal__footer}>
          <div className={styles.modal__footer_btns}>
            <button
              className={cn(
                styles.modal__footer_btn,
                styles.modal__footer_btn_accept,
                isCheck ? styles.modal__footer_btn_accept_active : ""
              )}
              onClick={sendAccept}
            >
              {t("Accept")}
            </button>
            <button
              className={styles.modal__footer_btn}
              onClick={() => store.logout()}
            >
              {t("Decline")}
            </button>
          </div>
        </div>
        <div className={styles.modal__footer_row}>
          <a
            href={`${FRONT_URL}/files/DAG GmbH.zip`}
            className={styles.modal__download}
            download
          >
            {t("Download contract")}
          </a>

          <div
            className={cn(
              styles.modal__footer_scroll,
              isEndReached ? styles.modal__footer_scroll_hide : ""
            )}
            onClick={scrollToBottom}
          >
            {t("Scroll to the bottom")}
            <ArrowDropdown color="#509c5a" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalFirstEnterSale;
